import CardAccountInfo from "./CardAccountInfo";
export default CardAccountInfo;
